import StatusCode from './StatusCode'

export default StatusCode
